import React, { useState, useEffect } from 'react';
import { Select, MenuItem } from '@material-ui/core';
import '../styles.scss';

function UncheckedList(props) {
  const {
    providerIds,
    providerCalRefs,
    providersById,
    toggleCheckbox,
    filterList,
    filterListUpdate,
  } = props;

  const [filterIds, setFilterIds] = useState(null);

  useEffect(() => {
    filterOptions();
  }, [filterList]);

  const handleChange = event => {
    let id = event.target.value;
    if (id !== 'more') {
      const checkedState = true;
      const updateFilterArray = filterList.map((inVal, i) => {
        if (inVal.id === id) {
          return { ...inVal, isChecked: checkedState };
        }
        return inVal;
      });
      filterListUpdate(updateFilterArray);
      filterOptions();
      toggleCheckbox(id, checkedState, 'select');
    }
  };

  const filterOptions = () => {
    let arr = [];
    filterList.map((item, i) => {
      if (!item.isChecked) {
        arr.push(item.id);
      }
    });
    setFilterIds(arr);
  };

  const unchecked = id => {
    if (!providerCalRefs[id]) {
      return true;
    }
    return false;
  };

  return (
    <Select value="more" className="menu-button" onChange={handleChange}>
      <MenuItem value="more" name="more" style={{fontWeight:"bold"}}>
        Add schedule
      </MenuItem>
      {filterIds?.map(id => {
        const { name } = providersById[id];
        if (unchecked(id)) {
          return (
            <MenuItem key={id} value={id} name={id} style={{whiteSpace:"normal"}}>
              {name}
            </MenuItem>
          );
        }
      })}
    </Select>
  );
}

export default UncheckedList;
